
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/coverage/flow-options",
      function () {
        return require("private-next-pages/docs/auth/coverage/flow-options.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/coverage/flow-options"])
      });
    }
  